const DOCUMENT_TYPE = {
  // APPROVAL: 'Approval',
  // CAMPUS_ORDER: 'Campus Order',
  // COST_TRANSFER: 'Cost Transfer',
  CREDIT_TO_ACCOUNT: 'Credit to Account',
  // DEPOSIT: 'Deposit',
  INVOICE: 'Invoice',
  JOURNAL_ENTRY: 'Journal Entry',
  // LPO: 'LPO',
  ORDER_CONFIRMATION: 'Order Confirmation',
  // PACKING_SLIP: 'Packing Slip',
  PAYMENT_REQUEST: 'Payment Request',
  PO: 'PO',
  QUOTE: 'Quote',
  RECEIPT: 'Receipt',
  REQUISITION: 'Requisition',
  // STIPEND: 'Stipend',
  // TRAVEL: 'Travel',
  // SHIPPING_CONFIRMATION: 'Shipping Confirmation',
  SERVICE_CONTRACT: 'Service Contract',
  SOLE_SOURCE: 'Sole Source',
  OTHER: 'Other',
};

const getDocumentType = (key) => {
  return key ? DOCUMENT_TYPE[key.toUpperCase()] || key : '';
};

module.exports = {
  DOCUMENT_TYPE,
  getDocumentType,
};
